import styled from 'styled-components';

export const Slot = styled.div`
  border: 1.41135px solid #40e5a0;
  border-radius: 8.46812px;
  width: 77.5%;
  height: 2rem;
  margin-top: 0.3rem;
  position: relative;

  font-family: 'Sora';
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #118052;
  padding: 0.68rem 1rem 0rem 1rem;
  cursor: pointer;

  display: flex;
  justify-content: space-between;
`;

export const UList = styled.ul`
  position: absolute;
  width: 16.2rem;
  left: -8.2rem;
  top: 3.5rem;
  border: 1.41135px solid #40e5a0;
  border-radius: 8.46812px;
  padding: 0;
  margin: 0;
  list-style: none outside none;
  max-height: 8rem;
  overflow-y: auto;

  cursor: pointer;

  font-family: 'Sora';
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #118052;

  /* 
  background-color: #cff8e7;
  margin-left: -1rem;
  transition: max-height 0.2s;
   */
  ::-webkit-scrollbar {
    width: 0.3rem;
    background: #cff8e7;
    border-top: 1.41135px solid #40e5a0;
    border-radius: 8.46812px;
  }

  ::-webkit-scrollbar-thumb {
    background: #118052;
    border-radius: 12px;
  }

  li:hover {
    filter: brightness(90%);
  }

  li {
    padding: 0.68rem 0rem 0.61rem 1rem;
    background-color: #cff8e7;

    display: flex;
    justify-content: space-between;
  }
  li:nth-child(1) {
    border-top-left-radius: 8.46812px;
    border-top-right-radius: 8.46812px;
  }
  li:last-child {
    border-bottom-left-radius: 8.46812px;
    border-bottom-right-radius: 8.46812px;
  }
`;

export const VersionCheck = styled.div`
  width: 1rem;
  height: 1rem;
  margin-right: 1rem;

  path {
    stroke: #118052;
  }
`;

export const MenuUnmarked = styled.div`
  width: 1rem;
  height: 1rem;
  margin-right: 1rem;
  border-radius: 100%;
  background-color: #eee;
`;
